<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.language_popup">
  <app-popup-header title="{{localService.languageContent.language_popup.title}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-md-5">
        <div class="row">
          <div class="col-3">
            <input autocomplete="off" type="text" *ngIf="id == ''" [(ngModel)]="wrapper.content.v1" title="{{localService.languageContent.language_popup.code}}" placeholder="{{localService.languageContent.language_popup.code}}" />
            <input autocomplete="off" type="text" *ngIf="id != ''" readonly [(ngModel)]="wrapper.content.v1" title="{{localService.languageContent.language_popup.code}}" placeholder="{{localService.languageContent.language_popup.code}}" />
          </div>
          <div class="col-9">
            <input autocomplete="off" type="text" [ngClass]="wrapper.content.v2 != '' ? wrapper.content.v1 : ''" [(ngModel)]="wrapper.content.v2" title="{{localService.languageContent.language_popup.name}}" placeholder="{{localService.languageContent.language_popup.name}}" />
          </div>
        </div>
        <app-language-container [MaxLength]="20" [id]="elementIds.language_id" [(languageContents)]="wrapper.languageContents" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)" [isModeChangeAllowed]="false" [IsShowAllLanguages]="true"></app-language-container>
      </div>
      <div class="col-md-7">
        <div>
          <textarea [ngClass]="wrapper.content.v3 != '' ? 'en' : ''" [(ngModel)]="wrapper.content.v3" title="{{localService.languageContent.language_popup.style}}" placeholder="{{localService.languageContent.language_popup.style}}"></textarea>
        </div>
        <div>
          <textarea [ngClass]="wrapper.content.v4 != '' ? 'en' : ''" [(ngModel)]="wrapper.content.v4" title="{{localService.languageContent.language_popup.style_ext}}" placeholder="{{localService.languageContent.language_popup.style_ext}}"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
